import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { getToken,getName,getUserId } from '@/utils/auth' 


Vue.use(Router)

 
export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/pages/home')
  },
  {
    path: '/home',
    component: () => import('@/pages/home')
  },
  {
    path: '/updatePwd',
    component: () => import('@/pages/updatePwd')
  }, 
  {
    path: '/sendCard',
    component: () => import('@/pages/sendCard'),
    meta: {
      keepAlive: false 
    }
  },{
    path: '/sendCardAdd',
    component: () => import('@/pages/sendCard/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sendCardView',
    component: () => import('@/pages/sendCard/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sendCollect',
    component: () => import('@/pages/sendCollect'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/weightpq',
    component: () => import('@/pages/weight/indexpq'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/weightpqAdd',
    component: () => import('@/pages/weight/addpq'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/weight',
    component: () => import('@/pages/weight/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/weightAdd',
    component: () => import('@/pages/weight/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/weightView',
    component: () => import('@/pages/weight/view'),
    meta: {
      keepAlive: false 
    }
  },{
    path: '/buyChick',
    component: () => import('@/pages/buyChick/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/buyChickAdd',
    component: () => import('@/pages/buyChick/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/buyChickView',
    component: () => import('@/pages/buyChick/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/askPrice',
    component: () => import('@/pages/askPrice/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/askPriceAdd',
    component: () => import('@/pages/askPrice/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/askPriceView',
    component: () => import('@/pages/askPrice/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/carcassRatio',
    component: () => import('@/pages/carcassRatio/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/carcassRatioAdd',
    component: () => import('@/pages/carcassRatio/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/carcassRatioView',
    component: () => import('@/pages/carcassRatio/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/weightContractEntry',
    component: () => import('@/pages/weight/entry'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/weightContractCNEntry',
    component: () => import('@/pages/weight/entryCN'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/recoveryCountReport',
    component: () => import('@/pages/recoveryCount/report'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/profit',
    component: () => import('@/pages/report/profit'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/total',
    component: () => import('@/pages/report/total'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/countContractAnalysis',
    component: () => import('@/pages/count/analysis'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/dailyWage',
    component: () => import('@/pages/dailyWage'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/dailyWageAdd',
    component: () => import('@/pages/dailyWage/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/dailyWageView',
    component: () => import('@/pages/dailyWage/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/dailyWageDay',
    component: () => import('@/pages/dailyWage/day'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/productionOutput',
    component: () => import('@/pages/productionOutput'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/productionOutputAdd',
    component: () => import('@/pages/productionOutput/add'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/sale',
    component: () => import('@/pages/sale/home'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/index',
    component: () => import('@/pages/sale/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/product',
    component: () => import('@/pages/sale/product'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/order',
    component: () => import('@/pages/sale/order.vue'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/orderList',
    component: () => import('@/pages/sale/orderList'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/storeList',
    component: () => import('@/pages/sale/storeList'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/storeView',
    component: () => import('@/pages/sale/storeList/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/saleLoading',
    component: () => import('@/pages/sale/saleLoading'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/saleLoadingView',
    component: () => import('@/pages/sale/saleLoading/view'),
    meta: {
      keepAlive: false 
    }
  }, 
  {
    path: '/sale/shopping',
    component: () => import('@/pages/sale/shopping'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/order/index',
    component: () => import('@/pages/sale/order/index'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/orderView',
    component: () => import('@/pages/sale/orderView'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/success',
    component: () => import('@/pages/sale/success'),
    meta: {
      keepAlive: false 
    }
  },{
    path: '/sale/customerReceipt',
    component: () => import('@/pages/sale/customerReceipt'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/customerReceiptAdd',
    component: () => import('@/pages/sale/customerReceipt/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/customerReceiptView',
    component: () => import('@/pages/sale/customerReceipt/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/sale/customerReceiptEntry',
    component: () => import('@/pages/sale/customerReceipt/entry'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLog',
    component: () => import('@/pages/breedLog'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogAdd',
    component: () => import('@/pages/breedLog/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogAdd/feed',
    component: () => import('@/pages/breedLog/addFeed'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogAdd/egg',
    component: () => import('@/pages/breedLog/addEgg'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogAdd/dead',
    component: () => import('@/pages/breedLog/addDead'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogView',
    component: () => import('@/pages/breedLog/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogReport',
    component: () => import('@/pages/breedLog/report'),
    meta: {
      keepAlive: true 
    }
  },
  {
    path: '/breedLogGoods',
    component: () => import('@/pages/breedLogGoods'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogGoodsAdd',
    component: () => import('@/pages/breedLogGoods/add'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogGoodsView',
    component: () => import('@/pages/breedLogGoods/view'),
    meta: {
      keepAlive: false 
    }
  },
  {
    path: '/breedLogGoodsReport',
    component: () => import('@/pages/breedLogGoods/report'),
    meta: {
      keepAlive: true 
    }
  },
  {
    path: '/updateFarm',
    component: () => import('@/pages/farm/index'),
    meta: {
      keepAlive: true 
    }
  },{
    path: '/Page401',
    component: () => import('@/pages/error-page/401')
  }
]

const createRouter = () => new Router({ 
  routes: constantRoutes,
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

import * as dd from 'dingtalk-jsapi'; 
const router = createRouter()

router.beforeEach((to, from, next) => {
  console.log(to) 
  //部署需要去掉 next() return  更改缓存 auth
  // next() 
  // return 
  var fullPath = to.fullPath  
  
  // const token ='' // 获取token
  // const userId = ''// 获取userId 


   const token =getToken() // 获取token
  //  console.log(token)
   const userId = getUserId()// 获取userId 
  // const corpId = 'ding03d78e4c44234b6135c2f4657eb6378f' // 测试 钉钉ID 4342154725
  // const clientId = 'dingvojqiqkwjuy0ommx' //测试 钉钉内应用id   
  const corpId = 'ding0a72d53f2c87a522a39a90f97fcb1e09'// 宁泽
  const clientId = 'ding5uchqtznww3v1mjf '//宁泽  钉钉内应用id  
  // const corpId = 'ding03d78e4c44234b6135c2f4657eb6378f'//演示 钉钉ID 4342154725
  // const clientId = 'dingdbpkwr7k7evfmjpk'//演示 钉钉内应用id  
  // const openUrl = `http://localhost:3000?corpid=${corpid}`
  
  const href = window.location.href 
    
  const whiteList = ['/Page401','/downFile'] // 免登录白名单
  let isCur = false // 是否免登录
  setTimeout(() => {
    // 判断白名单
    for (const i of whiteList) {
      if (to.path == i) {
        isCur = true
      }
    }
    if (isCur) { 
      next() // 白名单内不做登录判断，直接next
    } else { 
      if (!token||!userId) {
        if(dd.env.platform !=="notInDingTalk"){
          dd.requestAuthCode({
            corpId: corpId,
            clientId: clientId,
            onSuccess: function (result) { 
                const { code } = result; 
                // 获得授权后，不存在登录信息
                const fd = {
                  code: code,
                  corpId: corpId
                }
                // 接口请求获取登录信息，根据自己逻辑配置
                store.dispatch('user/login', fd).then((res) => { 
                  var userId = getUserId() 
                  if(!userId){
                  next({
                      path: '/Page401'
                    })
                    return
                  } 
                  if(fullPath=='/'){
                    next({
                      path: '/home'
                    })
                    return
                  }else{
                    next({
                      path: fullPath
                    })
                    return
                  }
                }).catch(() => {
                })  
            },
            onFail: function (err) {},
          });  
        }else{
          alert("请用钉钉登录")
        }
      } else{ 
        // 已经存在登录信息，有token，判断token是否过期
        //store.dispatch('CheckToken').then((res) => {
          // 判断token是否过期，以及token过期后清除token的操作可以在request的拦截中进行，也可以在CheckToken中进行
        //  if (res.code == 200) {
            // token未过期，直接登录 
            if(fullPath=='/'){
              next({
                path: '/home'
              })
              return
            }else{
              next()
              return
            }
        //  } else if (res.code == 401) {
            // token已过期，重新授权登录
        //    window.location.href = openUrl
        //  }
        //}).catch(() => {
        //})
      } 
    }
  }, 0)
})
 
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher 
}

export default router
